import { Fragment } from 'react';
import { Link } from '@customerio/pluma-components/react';
import { parseServerMessage } from '../utils/server-error-message';

type ServerErrorMessageProps = {
  /** An attribute error detail from the API; may carry an inline `<a href>`. */
  message: string;
};

/** Renders an API error detail, turning any inline anchor into a link that opens in a new tab. */
export function ServerErrorMessage({ message }: ServerErrorMessageProps) {
  return (
    <>
      {parseServerMessage(message).map((segment, index) =>
        segment.type === 'link' ? (
          <Link
            key={index}
            href={segment.href}
            variant="secondary"
            color="inherit"
            isUnderlined
            target="_blank"
            rel="noreferrer noopener"
          >
            {segment.text}
          </Link>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
